/**
 * PlaygroundENOrbPlaygroundRoute
 *
 * Page component for PlaygroundENOrbPlaygroundRoute
 * Path: /playground
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlaygroundENOrbPlaygroundPageView as __PlaygroundENOrbPlaygroundPageView } from '@/components/traits/PlaygroundENOrbPlaygroundPageView';
import { PlaygroundENOrbPlaygroundAnalyticsView as __PlaygroundENOrbPlaygroundAnalyticsView } from '@/components/traits/PlaygroundENOrbPlaygroundAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface PlaygroundENOrbPlaygroundRouteProps {
  // Add any page-level props here
}

export function PlaygroundENOrbPlaygroundRoute(_props: PlaygroundENOrbPlaygroundRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-playground:meta.title"],"description":["i18n/t","std-orb-playground:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/playground"},{"locale":"ar","path":"/ar/playground"},{"locale":"sl","path":"/sl/playground"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlaygroundENOrbPlaygroundPageView config={{ initPayload: __navState }} />
          <__PlaygroundENOrbPlaygroundAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlaygroundENOrbPlaygroundRoute;
